// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"648b97e2","667":"2c824cba","726":"3f3bafb2"}[chunkId] + ".chunk.js";
};